import { Box, Stack } from '@mui/material';
import getConfig from 'next/config';
import { useEffect, useRef } from 'react';

import useResponsive from '@/components/hooks/useResponsive';
import HeroContent from '@/components/pages/visitorHome/VisitorHomeRebrandLayout/Hero/HeroContent';
import HeroZipPanel from '@/components/pages/visitorHome/VisitorHomeRebrandLayout/Hero/HeroZipPanel';

const {
  publicRuntimeConfig: { CZEN_GENERAL },
} = getConfig();

const HeroVideo = () => {
  const { isMobile } = useResponsive();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.defaultMuted = true;
      videoRef.current.muted = true;
      videoRef.current.playbackRate = 0.75;
    }
  }, [videoRef]);

  return (
    <Box data-testid="hero-video">
      <Stack
        gap={{ xs: 4, md: 0 }}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          pt: { xs: 3, md: 5 },
          px: { xs: 3, md: 10 },
          pb: 10,
          height: {
            xs: '246px',
            sm: '544px',
            md: '564px',
          },
          borderRadius: {
            xs: '0 0 70px 70px',
            sm: '0 0 120px 120px',
          },
        }}>
        <Box
          sx={{
            maxWidth: {
              xs: '100%',
              sm: '1280px',
            },
          }}>
          <HeroContent />

          {!isMobile && <HeroZipPanel />}
        </Box>

        <Box
          ref={videoRef}
          poster="https://www.care.com/s/cms/web/vhp/hero/hero-video-poster.jpg"
          component="video"
          sx={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: -1,
          }}
          playsInline
          autoPlay
          controls={false}
          muted
          loop>
          <source src={`${CZEN_GENERAL}/s/d/videos/vhp-hero-video.mp4`} type="video/mp4" />
        </Box>
      </Stack>
      {isMobile && <HeroZipPanel />}
    </Box>
  );
};

export default HeroVideo;
